import { SxProps, Theme } from '@mui/material'

export const debugSx: SxProps<Theme> = {
  backgroundColor: '#ff000033',
  borderColor: 'red',
  borderWidth: 1,
  borderStyle: 'dashed',
  borderRadius: 2,
}
